export const ErrorCode = {
  'ROTATIONAL_PAGES_FOUND': 'statement-rotational-error-code-message',
};
